<template>
  <v-lazy>
    <div>
      <HomeHeader class="mx-5 mt-8" @filterChange="filterChange" />
      <HomeInfoPanel
        class="mx-5 mt-10"
        :accounts="accounts"
        :procedures="procedures"
        :filterActive="filter"
      />
      <HomeChartsPanel class="mx-3 mt-5" :accounts="accounts" :procedures="procedures" />
      <HomeLocalitiesPanel class="mx-8 mt-5" />
    </div>
  </v-lazy>
</template>

<script>
import HomeHeader from "@/components/organisms/Home/home-header";
import HomeInfoPanel from "@/components/organisms/Home/home-info-panel";
import HomeChartsPanel from "@/components/organisms/Home/home-charts-panel";
import HomeLocalitiesPanel from "@/components/organisms/Home/home-localities-panel";

export default {
  components: {
    HomeHeader,
    HomeInfoPanel,
    HomeChartsPanel,
    HomeLocalitiesPanel
  },
  data() {
    return {
      accounts: [],
      procedures: [],
      filter: null
    };
  },
  methods: {
    filterChange(value) {
      this.filter = value;
    }
  },
  beforeMount() {
    this.accounts = this.$store.getters.accounts;
    this.procedures = this.$store.getters.procedures;
  }
};
</script>

<style scoped>
</style>